export default __webpack_public_path__ + "static/N0077-32fab962307a11dca030dff0c2dfc1f5.png";